import { ChangeEvent, forwardRef } from 'react';

import { useAppSelector } from 'store/store-hooks';
import { selectHelpMode } from 'components/app/_mediator/app-data.slice';

import { ReactComponent as SearchIcon } from 'assets/ui/search.svg';
import { ReactComponent as CrossIcon } from 'assets/ui/cross.svg';
import { Tooltip } from 'components/UI/tooltip/tooltip';
import styles from './_elements.module.scss';

type Props = {
  searchValue: string;
  updateSearchValue: (event: ChangeEvent<HTMLInputElement>) => void;
  clearSearchValue: () => void;
};

export const HeaderSearch = forwardRef<HTMLInputElement, Props>(
  ({ clearSearchValue, searchValue, updateSearchValue }, ref) => {
    const helpMode = useAppSelector(selectHelpMode);
    return (
      <Tooltip tip="Search table" showTooltip={helpMode} position="left">
        <div className={styles.HeaderSearch}>
          <SearchIcon className={styles.HeaderSearch__ico} />
          <input ref={ref} value={searchValue} onChange={updateSearchValue} />
          {searchValue && (
            <div className={styles.HeaderSearch__clear} onClick={clearSearchValue}>
              <CrossIcon width={18} height={18} />
            </div>
          )}
        </div>
      </Tooltip>
    );
  }
);
